import { render, staticRenderFns } from "./pre_date.vue?vue&type=template&id=35d31f1e&scoped=true"
import script from "./pre_date.vue?vue&type=script&lang=js"
export * from "./pre_date.vue?vue&type=script&lang=js"
import style0 from "./pre_date.vue?vue&type=style&index=0&id=35d31f1e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d31f1e",
  null
  
)

export default component.exports